import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";

import GetDomainButton from "./GetDomainButton";
import { isBannerEnabled, getParkWebHegBannerText } from "../../commons/banner";
import { ReactComponent as Reglogo } from "./123Reg.svg";
import { AdContent } from "../AdContent";
import { FooterParkWeb } from "./FooterParkWeb";
import classes from "./HegLayout.module.scss";
import { useLanderConfig } from "../../commons/ConfigContext";

const HegLayout = () => {
  const { landerConfig } = useLanderConfig();
  const domainContent = isBannerEnabled(landerConfig) ? (
    <div>
      <Domain landerConfig={ landerConfig } />
      <DomainInfo landerConfig={ landerConfig } />
      <GetDomainButton
        landerConfig={ landerConfig }
        className={ classes.getDomainButton }
      />
    </div>
  ) : null;

  return (
    <div className={ classes.hegLayout }>
      <div className={ classes.contentLayout }>
        <div className={ classes.domainBanner } data-testid="domainBanner">
          <div className={ classes.headerLogoWrapper }>
            <Reglogo />
          </div>

          <div className={ classes.headerText }>
            <div className={ classes.headerTextTitle }>
              {landerConfig?.lander?.domainDisplayName}
            </div>
            {domainContent}
          </div>
          <div className={ classes.headerFooter }>
            <FormattedMessage
              id="hegFooterText"
              values={{
                hegFooterTextHegSiteLink: (
                  <a
                    href="https://www.123-reg.co.uk/"
                    rel="nofollow"
                    style={{ color: "inherit" }}
                  >
                    <FormattedMessage id="hegFooterTextHegSiteLink" />
                  </a>
                ),
              }}
            />
          </div>
        </div>
        <div className={ classes.adsBackground }>
          <AdContent />
        </div>
        <FooterParkWeb
          copyrightTextId="parkwebhegcopyrightText"
          parkwebDisclaimerText="parkwebhegDisclaimerText"
        />
      </div>
    </div>
  );
};
export default HegLayout;

export function DomainInfo({ landerConfig }) {
  const intl = useIntl();
  const messageId = getParkWebHegBannerText(landerConfig);
  if (!messageId) {
    return null;
  }
  return (
    <div className={ classes.domainInfo } data-testid="domainInfo">
      {intl.formatMessage({ id: messageId })}
    </div>
  );
}
DomainInfo.propTypes = {
  landerConfig: PropTypes.object,
};

function Domain({ landerConfig }) {
  const domain = landerConfig?.domain?.rootDomainDisplayText;
  if (!domain) {
    return null;
  }
  return (
    <div className={ classes.domain } data-testid="domain">
      {domain}
    </div>
  );
}

Domain.propTypes = {
  landerConfig: PropTypes.object.isRequired,
};

HegLayout.propTypes = {};
